import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.uat.onyxcentersource.com',
  hostname: 'pioneer.uat.onyxcentersource.com',
  portalUrl: 'https://portal.uat.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd-service.uat.onyxcentersource.com/api',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  emailValidation: true,
  cwr: {
    enable: true
  },
  invoiceHistoryUrl: 'https://ooiv-invoice-history.uat.onyxcentersource.com',
  agencyDashboardUrl: 'https://agency-dashboard.uat.onyxcentersource.com',
  showAgencyDashboard: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.uat.ts